import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-preview-car-full',
  templateUrl: './preview-car-full.component.html',
  styleUrls: ['./preview-car-full.component.scss']
})
export class PreviewCarFullComponent implements OnInit {

  @Input() car:any = {}


  constructor() { }

  ngOnInit() {
  }

}
